import axios, { AxiosResponse } from "axios"

export type Computer = {
    id: string,
    name: string,
    state: string
}

export type Printer = {
    id: string,
    name: string,
    state: string
}

const getComputers = async ():Promise<Computer[]> =>{
    try {
        const response:AxiosResponse<Computer[],any> = await axios.get('api/printnode/computers')
        return response.data
    } catch(error:any) {
        throw error
    }
}

const getComputerPrinters = async (computerId:string):Promise<Computer[]> =>{
    try {
        const response:AxiosResponse<Printer[],any> = await axios.get(`api/printnode/computers/${computerId}/printers`)
        return response.data
    } catch(error:any) {
        throw error
    }
}

const getPrinters = async (printerIds:string[]):Promise<Printer[]> =>{
    try {
        if(printerIds.length === 0) return []
        const response:AxiosResponse<Printer[],any> = await axios.get(`api/printnode/printers/${printerIds.join(',')}`)
        return response.data
    } catch(error:any) {
        throw error
    }
}

export { getComputers, getComputerPrinters, getPrinters }